import { useState, useContext, Fragment } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContext";
import { useEmailUpdateVerification } from "../utils/verifyEmailUpdate";
import { toast, ToastContainer } from "react-toastify";
import { ReactComponent as BlackVatugIcon } from "../../../Asset/black.svg";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

const DoubleCheckConfirmation = () => {
  const { userType } = useContext(AuthContext);
  const navigate = useNavigate()
  const { mutate: verifyEmailUpdate } = useEmailUpdateVerification();
  const [formData, setFormData] = useState({
    oldEmail: "",
    newEmail: "",
    OTP: "",
    OTP1: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.oldEmail) formErrors.oldEmail = "Old email is required.";
    if (!formData.newEmail) formErrors.newEmail = "New email is required.";
    if (!formData.OTP) formErrors.OTP = "OTP is required.";
    if (!formData.OTP1) formErrors.OTP1 = "Second OTP is required.";
    if (!formData.password) formErrors.password = "Password is required.";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);  
      verifyEmailUpdate(formData, {
        onSuccess: () => {
          toast.success("Email updated successfully!");
          setIsLoading(false);  
        },
        onError: (error) => {
          toast.error(error.message || "Failed to verify email update.");
          setIsLoading(false);  
        },
      });
    }
  };

  return (
    <Fragment>
      <ToastContainer />
      <div className="signeup-account">
        <div className="content-card">
        <div className="wrap">
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <Link to="/double_check" >Back</Link>
        </div>
          <form onSubmit={handleSubmit}>
            <h3>Confirm Email Update</h3>
            <p>For {userType}</p>

            <label>
              <input
                type="email"
                placeholder="Enter old email address"
                name="oldEmail"
                value={formData.oldEmail}
                onChange={handleInputChange}
              />
              {errors.oldEmail && <p className="error">{errors.oldEmail}</p>}
            </label>

            <label>
              <input
                type="text"
                placeholder="Enter OTP for old email address"
                name="OTP"
                value={formData.OTP}
                onChange={handleInputChange}
              />
              {errors.OTP && <p className="error">{errors.OTP}</p>}
            </label>

            <label>
              <input
                type="email"
                placeholder="Enter new email address"
                name="newEmail"
                value={formData.newEmail}
                onChange={handleInputChange}
              />
              {errors.newEmail && <p className="error">{errors.newEmail}</p>}
            </label>

            <label>
              <input
                type="text"
                placeholder="Enter OTP for new email address"
                name="OTP1"
                value={formData.OTP1}
                onChange={handleInputChange}
              />
              {errors.OTP1 && <p className="error">{errors.OTP1}</p>}
            </label>

            <label>
              <input
                type="password"
                placeholder="Enter your password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />
              {errors.password && <p className="error">{errors.password}</p>}
            </label>

            <button type="submit" disabled={isLoading}>
              {isLoading ? "Verifying..." : "Verify and Update Email"}
            </button>
          </form>
        </div>
        <div className="img"></div>
      </div>
    </Fragment>
  );
};

export default DoubleCheckConfirmation;

